/* eslint-disable import/first */
import Vue from "vue";
import {EventBus} from "../../event-bus.js";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import List from "./components/List.vue";
import {afterEachRouteChange} from "../router-helpers.js";

export function buildRouter() {
	const routes = [
		{path: "/list", component: List}
	];

	const router = new VueRouter({
		routes, mode: "abstract"
	});
	router.afterEach(afterEachRouteChange(routes, EventBus, router));
	return {router};
}
